var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0835 13.7507H11.9168V15.584H10.0835V13.7507ZM10.0835 6.41732H11.9168V11.9173H10.0835V6.41732ZM10.991 1.83398C5.931 1.83398 1.8335 5.94065 1.8335 11.0007C1.8335 16.0607 5.931 20.1673 10.991 20.1673C16.0602 20.1673 20.1668 16.0607 20.1668 11.0007C20.1668 5.94065 16.0602 1.83398 10.991 1.83398ZM11.0002 18.334C6.9485 18.334 3.66683 15.0523 3.66683 11.0007C3.66683 6.94898 6.9485 3.66732 11.0002 3.66732C15.0518 3.66732 18.3335 6.94898 18.3335 11.0007C18.3335 15.0523 15.0518 18.334 11.0002 18.334Z",
    fill: "#D8302B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AlertError.86b9c4450b230eb5594130b3598a4141.svg";